import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_20, IconNG } from '../../Icon'
import { FilePreviewDeleteButton } from '../FilePreviewDeleteButton'

import * as styles from './FilePreviewOverlay.module.css'

import SelectedIcon from '../../../icons/unique/success.svg'

function FilePreviewOverlay({
  allowAvatarSelection,
  className = styles.FilePreviewOverlay,
  deleteButtonQaName,
  disabled,
  error,
  filename,
  selected,
  tooltip,
  onRemove,
  onSelectAvatar,
}) {
  const { t } = useTranslation()

  const overlayClassName = classnames(className, {
    [styles.disabled]: disabled,
    [styles.error]: error,
    [styles.selected]: selected,
  })

  return (
    <FloatingTooltip content={tooltip || filename} disabled={disabled}>
      <div className={overlayClassName}>
        {onRemove && !disabled ? (
          <FilePreviewDeleteButton
            className={styles.deleteButton}
            qaName={deleteButtonQaName}
            onClick={onRemove}
          />
        ) : null}
        {allowAvatarSelection ? (
          <FloatingTooltip
            content={t(
              selected
                ? 'File.UnselectImageAsAvatarKey'
                : 'File.SelectImageAsAvatarKey'
            )}
            disabled={disabled}
          >
            <div className={styles.selectIcon} onClick={onSelectAvatar}>
              {selected ? (
                <IconNG
                  Icon={SelectedIcon}
                  iconProps={{ className: styles.selectedIcon }}
                  size={ICON_HEIGHT_20}
                />
              ) : (
                <div className={styles.emptySelectedIcon} />
              )}
            </div>
          </FloatingTooltip>
        ) : null}
      </div>
    </FloatingTooltip>
  )
}

export default FilePreviewOverlay
